export const publicDico = {
    general: {
        assets_url: "/espace-client/assets",
    },
    header: {
        logo: {
            baseline: "L'information sociale en clair",
        },
        button: {
            label: "Votre espace client",
        },
    },
    offers: {
        formText: "Merci de renseigner le formulaire ci-dessous",
        selectUserLabel: "Choissisez le nombre d’utilisateurs :",
        tax: "HT",
        year: "an",
        title: "Nos offres",
        price: "(Tarif par utilisateur)",
        mentions:
            "Document à imprimer et à retourner dûment complété à l'adresse indiquée sur le formulaire d'abonnement. Cliquer sur le lien ci-dessous pour le télécharger.",
        cta: "En savoir plus sur l’offre",
        select: "Choisir cette offre",
        download: "Télécharger le formulaire d'abonnement",
        offers: {
            offer1: {
                title: "Diode Business",
                subtitle: "Offre recommandée pour les entreprises",
                price: "90",
                items: [
                    {
                        icon: "book",
                        label: "Consultation de 1 convention collective (possibilités d’adaptation de l’offre si plusieurs secteurs d’activité)",
                    },
                    {
                        icon: "search",
                        label: "Veille actualité sociale",
                    },
                    {
                        icon: "favorite",
                        label: "Alertes sur la convention collective choisie",
                    },
                ],
                link: "/offre-business",
            },
            offer2: {
                title: "Diode Consulting",
                subtitle: "Offre recommandée aux métiers de conseil aux entreprises",
                price: "830",
                items: [
                    {
                        icon: "book",
                        label: "Consultation de toutes les conventions collectives",
                    },
                    {
                        icon: "search",
                        label: "Veille actualité sociale",
                    },
                    {
                        icon: "favorite",
                        label: "Alertes sur 40 conventions collectives favorites",
                    },
                ],
                link: "/offre-consulting",
            },
            offer3: {
                title: "Diode Corporate",
                subtitle: "Offre recommandée aux métiers de vente de produits d’assurance",
                price: "1550",
                items: [
                    {
                        icon: "book",
                        label: "Consultation de toutes les conventions collectives",
                    },
                    {
                        icon: "search",
                        label: "Veille actualité sociale",
                    },
                    {
                        icon: "favorite",
                        label: "Alertes sur 40 conventions collectives favorites",
                    },
                    {
                        icon: "health",
                        label: "Alertes maladie, accident et prévoyance",
                    },
                ],
                link: "/offre-corporate",
            },
        },
    },
    login: {
        title: "Votre espace client Diode",
        subtitle: "Accès à votre espace personnalisé",
        body1: "Visualisez les obligations d’une ou plusieurs  conventions collectives en vous assurant un service de veille.",
        connexion: {
            title: "Connectez-vous",
            submit_cta: "Connexion",
            first_connexion_cta: "Première connexion sur le nouveau site",
            lost_password_cta: "Mot de passe oublié ?",
        },
        lost_password: {
            title: "Mot de passe perdu ?",
            submit_cta: "Réinitialiser le mot de passe",
            back_cta: "Retour",
        },
        first_connexion: {
            title: "Première connexion sur le nouveau site",
            submit_cta: "Première connexion",
            back_cta: "Retour",
        },
        errors: {
            login_bad_credentials: "Les identifiants saisis sont incorrects.",
            forgot_password_sent_if_email_valid:
                "Si vous êtes abonné à notre service, vous recevrez un mail dans quelques instants.",
            first_connexion_invalid_email: "Veuillez renseigner votre email.",
            first_connexion_has_password:
                "Votre compte a déjà été activé. Si vous avez oublié votre mot de passe, veuillez utiliser le formulaire 'Mot de passe oublié'.",
            first_connexion_non_unique_email:
                "Cet email est attribué à plusieurs comptes. Veuillez utiliser votre login.",
            first_connexion_non_unique_new_email: "Le mail renseigné est déjà existant.",
            first_connexion_sent_if_email_valid:
                "Si vous êtes abonné à notre service, vous recevrez un mail dans quelques instants.",
            "auth/reset-link-expired": "Ce lien est invalide, expiré ou déjà utilisé.",
            "sso/user-not-found":
                "Cet utilisateur n'est pas enregistré dans notre base de données, Veuillez contacter votre administrateur",
            "sso/invalid-token": "Token invalide",
            "sso/expired-token": "Token n'est plus valide ou expiré",
            "sso/invalid-email":
                "<p>L'adresse email renseignée est déjà associée à un compte Diode.</p><p>Veuillez <a href='/contact'>contacter notre service</a> client Diode pour en savoir plus.</p>",
            "sso/general-error":
                "<p>Une erreur technique est survenue.</p><p>Veuillez <a href='/contact'>contacter notre service</a> client Diode pour en savoir plus.</p>",
            "sso/general-error-alm":
                "<p>L’adresse email renseignée est invalide.</p><p>Veuillez <a href='/contact'>contacter notre service</a> client Diode pour en savoir plus.</p>",
            expired_token: "Token n'est plus valide ou expiré",
            inactive_user: "Utilisateur inactif. Veuillez contacter le service client Diode",
            auth_general:
                "Une erreur technique est rencontrée. Veuillez contacter le service client Diode.",
        },
    },
    contact: {
        teaser: {
            image: "/images/teaser-contact.jpg",
            title: "Contactez-nous",
            subtitle: "Service client",
            text: "Notre service de relations clientèle est à votre écoute pour traiter vos demandes d’informations sur nos services et pour la gestion de vos abonnements.",
        },
        form: {
            title: "Vous souhaitez nous écrire ?",
            text: "Merci de renseigner le formulaire ci-dessous",
        },
        offers: {
            title: "Pas encore d’abonnement ?",
        },
        errors: {
            captcha_invalid: "Le captcha est incorrect, merci d’envoyer à nouveau votre message.",
            general: "Une erreur est survenue lors de l'envoi de votre message",
        },
    },
};
